import baseRequest from './useRequest';
import { customerFragment } from '@/hooks/shopify-hooks/fragments/strorefront/customerFragment';
import { mailingAddressFragment } from '@/hooks/shopify-hooks/fragments/mailingAddressFragment';
import { useScrmFetch } from "@/hooks/common/fetch/useFetch";
import { encryptData } from "@/utils/encryption.js"
import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
import { useFailMsgBox } from "@/hooks/common/msg-box/useFailMsgBox";
import { useCustomerApi } from '@/hooks/shopify-hooks/useShopifyUtils';
import {
  useDeleteLoginStorage
} from "@/hooks/shopify-hooks/useShopifyMessageEvent";
const { domain } = shopifyConst;
// 查询customer
export const fetchCustomer = async (accessToken) => {
  try {
    console.log('进来了')
    const query = `
      query customer($customerAccessToken: String!){
        customer(customerAccessToken: $customerAccessToken) {
          ...CustomerFragment
        }
      }
      ${customerFragment}
    `;
    const variables = {
      customerAccessToken: accessToken
    };
    const response = await baseRequest(query, variables);

    if (response?.errors) {
      await useDeleteLoginStorage(true);
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }


      throw new Error('Unnable to fetch Customer');
    }
    return response?.data?.customer;
  } catch (e) {
    console.log('catch--',e)
    console.error(e);
    return {}
  }
}

// 创建customer
export const customerCreate = async (customerInput) => {
  try {
    const query = `      
    mutation customerCreate($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
            customer {
                firstName
                lastName
                email
            }
            customerUserErrors {
                field
                message
            }
        }
    }
    `;
    const variables = {
      input: customerInput
    };
    const response = await baseRequest(query, variables);

    return response?.data?.customerCreate;
  } catch (e) {
    throw new Error(e);
  }
}

// 更新customer
export const customerUpdateAcceptsMarketing = async (customerModel, customerAccessTokenModel) => {
  try {
    const query = `      
      mutation customerUpdate($customer: CustomerUpdateInput!, $customerAccessToken: String!) {
        customerUpdate(customer: $customer, customerAccessToken: $customerAccessToken) {   
          customer {
            ...CustomerFragment
          }
          customerAccessToken {
            accessToken
            expiresAt
          }         
          customerUserErrors {
            code
            field
            message
          }
        }
      }
      ${customerFragment}
    `;
    const variables = {
      customer: customerModel,
      customerAccessToken: customerAccessTokenModel
    };
    const response = await baseRequest(query, variables);
    console.log('acceptsMarketing',response)
    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unable to update customer');
    }

    return response?.data?.customerUpdate;
  } catch (e) {
    console.error(e);
  }
}
export const customerEmailMarketingUnsubscribe = async (ccustomerModel,accessToken) => {
  try {
    const query = `      
    mutation customerEmailMarketingUnsubscribe {
        customerEmailMarketingUnsubscribe {
          emailAddress {
            emailAddress
            marketingState
          }
          userErrors {
            field
            message
            code
          }
        }
      }
    `;
 
    await useCustomerApi(accessToken, query, ccustomerModel,true);
    
  } catch (e) {
    console.error(e);
  }
}
// 邮件订阅
export const customerEmailMarketingSubscribe = async (customerModel,accessToken) => {
  try {
    const query = `      
    mutation customerEmailMarketingSubscribe {
  customerEmailMarketingSubscribe {
    emailAddress {
      emailAddress
      marketingState
    }
    userErrors {
      field
      message
    }
  }
}
    `;

    await useCustomerApi(accessToken, query, customerModel,true);
    
  } catch (e) {
    console.error(e);
  }
}

// 更新customer   加密密码登录
export const C4AcustomerUpdatePerson = async (customerModel, customerAccessTokenModel) => {
  try {
    console.log('customerModel.acceptsMarketing',customerModel,customerAccessTokenModel)
    const params = {
    }
    if(customerModel.acceptsMarketing) {
      await customerEmailMarketingSubscribe(params,customerAccessTokenModel)
    }else {
      await customerEmailMarketingUnsubscribe(params,customerAccessTokenModel)
    }
      // const C4aparams = {
      //   marketingState:customerModel.acceptsMarketing ? 'SUBSCRIBED' : 'UNSUBSCRIBED',
      //   marketingOptInLevel:"SINGLE_OPT_IN"
      // }
      // const resC4a = await useScrmShopifyFetch(`/api/gws-ext/customer/updateEmailMarketing?auth=${customerAccessTokenModel}&endpoint=${domain}`).post(C4aparams).json();
      // console.log('resC4a',resC4a)
  } catch (e) {
    console.error(e);
  }
}


// 更新customer   加密密码登录
export const customerUpdatePerson = async (customerModel, customerAccessTokenModel, validateParams, customOptions) => {
  try {
    if(!customerModel.email) {
      await customerUpdateAcceptsMarketing(customerModel,customerAccessTokenModel)
      return
    }
    const params = {
      email: await encryptData(customerModel.email),//加密
      firstName: await encryptData(customerModel.firstName),//加密
      lastName: await encryptData(customerModel.lastName),//加密
      phone: await encryptData(customerModel.phone),//加密
      customerAccessToken: customerAccessTokenModel
    }
    const res = await useScrmFetch(`/api/gws-ext/customer/modifyinfo?endpoint=${domain}`).post(params).json();
    const response = res.data.value
    if (!response || (res?.error && res?.error?.value)) { // 接口错误，端午，
      window.igws.$toast.open({
        status: "error",
        text: customOptions.personInfo.failPrompt, // 18
      });
      throw new Error('Unable to update customer');
    } else if (response?.data?.customerUpdate?.customerUserErrors.length) { // 指向性
      useFailMsgBox(response.data.customerUpdate.customerUserErrors[0].message); // 接口
      throw new Error(response.data.customerUpdate.customerUserErrors[0].message);
    } else if (response?.errors){
       useFailMsgBox(response?.errors); // 接口
      throw new Error(response?.errors);
    }
    return response?.data?.customerUpdate;
  } catch (e) {
    console.error(e);
  }
}

export const addBirthFn = async (customerModel, customerAccessTokenModel, validateParams, customOptions) => {
  try {
    const params = {
      birthday: customerModel.birthday,//加密
      customerAccessToken: customerAccessTokenModel
    }
    console.log('addBirthFn',params)
    const res = await useScrmFetch(`/api/gws-ext/customer/modifymetafield?endpoint=${domain}`).post(params).json();
    const response = res.data.value
    if (!response || (res?.error && res?.error?.value)) { // 接口错误，端午，
      window.igws.$toast.open({
        status: "error",
        text: customOptions.personInfo.failPrompt, // 18
      });
      throw new Error('Unable to update customer');
    } else if (response?.data?.customerUpdate?.userErrors.length) { // 指向性
      useFailMsgBox(response.data.customerUpdate.userErrors[0].message); // 接口
      throw new Error(response.data.customerUpdate.userErrors[0].message);
    } else if (response?.errors){
       useFailMsgBox(response?.errors); // 接口
      throw new Error(response?.errors);
    }
    return response?.data?.customerUpdate;
  } catch (e) {
    console.error(e);
  }
}

export const customerUpdate = async (customerModel, customerAccessTokenModel, validateParams, customOptions) => {
  const params = {
    newPassword: await encryptData(customerModel.password),
    customerAccessToken: customerAccessTokenModel,
    validateParams: validateParams
  }
  const response = await useScrmFetch(`/api/gws-ext/customer/modifypw?endpoint=${domain}`, customOptions).post(params).json();
  const responsedata = response.data.value
  if (!responsedata || (response?.error && response?.error?.value)) { //
    window.igws.$toast.open({
      status: "error",
      text: customOptions.security.failPrompt,
    });
    throw new Error('Unable to update customer')
  }
  if (responsedata?.data?.customerUpdate?.customerUserErrors?.length || responsedata?.errors?.length) {
    const resultMsg = responsedata?.data?.customerUpdate?.customerUserErrors[0].message || responsedata?.errors[0].message 
    useFailMsgBox(resultMsg);
    throw (new Error(resultMsg));
  }
  return responsedata?.data?.customerUpdate;
}

// 创建customer地址
export const customerAddressCreate = async (addressModel, customerAccessTokenModel) => {
  try {
    const query = `      
      mutation customerAddressCreate($address: MailingAddressInput!, $customerAccessToken: String!) {
        customerAddressCreate(address: $address, customerAccessToken: $customerAccessToken) {      
          customerAddress {
            ...MailingAddressFragment
          }          
          customerUserErrors {
            code
            field
            message
          }
        }
      }
      ${mailingAddressFragment}
    `;
    const variables = {
      address: addressModel,
      customerAccessToken: customerAccessTokenModel
    };
    const response = await baseRequest(query, variables);

    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unable to create customer address');
    }

    return response?.data?.customerAddressCreate;
  } catch (e) {
    console.error(e);
  }
}

// 删除customer地址
export const customerAddressDelete = async (customerAddressId, customerAccessTokenModel) => {
  try {
    const query = `      
      mutation customerAddressDelete($customerAccessToken: String!, $id: ID!) {
        customerAddressDelete(customerAccessToken: $customerAccessToken, id: $id) {
          customerUserErrors {
            field
            message
          }
          deletedCustomerAddressId
          userErrors {
            field
            message
          }
        }
      }            
    `;
    const variables = {
      customerAccessToken: customerAccessTokenModel,
      id: customerAddressId
    };
    const response = await baseRequest(query, variables);

    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unable to Delete customer address');
    }

    return response?.data?.customerAddressDelete;
  } catch (e) {
    console.error(e);
  }
}

// customer地址更新
export const customerAddressUpdate = async (addressModel, customerAddressId, customerAccessTokenModel) => {
  try {
    const query = `      
      mutation customerAddressUpdate($address: MailingAddressInput!, $id: ID!, $customerAccessToken: String!) {
        customerAddressUpdate(address: $address, customerAccessToken: $customerAccessToken, id: $id) {    
          customerAddress {
            ...MailingAddressFragment
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }
      ${mailingAddressFragment}
    `;
    const variables = {
      address: addressModel,
      customerAccessToken: customerAccessTokenModel,
      id: customerAddressId
    };
    const response = await baseRequest(query, variables);

    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unable to update customer address');
    }

    return response?.data?.customerAddressUpdate;
  } catch (e) {
    console.error(e);
  }
}

// 默认地址更新
export const customerDefaultAddressUpdate = async (customerAddressId, customerAccessTokenModel) => {
  try {
    const query = `      
      mutation customerDefaultAddressUpdate($addressId: ID!, $customerAccessToken: String!) {
        customerDefaultAddressUpdate(addressId: $addressId, customerAccessToken: $customerAccessToken) {    
          customer {
            id
            defaultAddress {
              id
            }
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }
    `;
    const variables = {
      customerAccessToken: customerAccessTokenModel,
      addressId: customerAddressId
    };
    const response = await baseRequest(query, variables);

    if (response?.errors) {
      if (response?.errors?.[0]?.message) {
        throw new Error(response.errors[0].message);
      }

      throw new Error('Unable to update customer default address');
    }

    return response?.data?.customerDefaultAddressUpdate;
  } catch (e) {
    console.error(e);
  }
}

export const storefrontCustomerApi = {
  fetchCustomer,
  customerUpdate,
  customerUpdatePerson,
  addBirthFn,
  C4AcustomerUpdatePerson,
  customerAddressCreate,
  customerAddressDelete,
  customerAddressUpdate,
  customerDefaultAddressUpdate
};


